const KIB = 1024;

export function formatBytes(bytes: number): string {
  if (bytes < KIB) return `${bytes} B`;
  const units = ["KB", "MB", "GB"];
  let value = bytes / KIB;
  let unit = 0;
  while (value >= KIB && unit < units.length - 1) {
    value /= KIB;
    unit += 1;
  }
  return `${value < 10 ? value.toFixed(1) : Math.round(value)} ${units[unit]}`;
}

export function formatDateTime(iso: string | null): string {
  if (!iso) return "—";
  const date = new Date(iso);
  if (Number.isNaN(date.getTime())) return iso;
  return date.toLocaleString(undefined, {
    year: "numeric",
    month: "short",
    day: "2-digit",
    hour: "2-digit",
    minute: "2-digit",
  });
}

export function formatDuration(ms: number): string {
  if (ms <= 0) return "—";
  const totalSeconds = Math.round(ms / 1000);
  const minutes = Math.floor(totalSeconds / 60);
  const seconds = totalSeconds % 60;
  if (minutes === 0) return `${seconds}s`;
  if (minutes < 60) return `${minutes}m ${seconds}s`;
  return `${Math.floor(minutes / 60)}h ${minutes % 60}m`;
}

/**
 * Audit rows and build rows store the actor as `user:naufal`, which keeps a
 * person distinguishable from `anonymous` or a future machine actor in the
 * database. The prefix is plumbing and has no business on screen, so it is
 * stripped here rather than in each of the three places that renders it.
 */
export function actorName(label: string | null | undefined): string {
  if (!label) return "—";
  return label.startsWith("user:") ? label.slice(5) : label;
}

/**
 * Analytics days are plain local calendar days (the server buckets in its own
 * timezone), so the UI must not go through `toISOString()`, which would shift
 * the day backwards for anyone east of UTC.
 */
export function dayString(date: Date): string {
  const month = `${date.getMonth() + 1}`.padStart(2, "0");
  const day = `${date.getDate()}`.padStart(2, "0");
  return `${date.getFullYear()}-${month}-${day}`;
}

/** A `YYYY-MM-DD` analytics day as "29 Sep 2026"; "—" when there is none. */
export function formatDay(day: string | null | undefined): string {
  if (!day) return "—";
  const date = new Date(`${day}T00:00:00`);
  if (Number.isNaN(date.getTime())) return day;
  return date.toLocaleDateString("id-ID", {
    day: "2-digit",
    month: "short",
    year: "numeric",
  });
}

export function daysAgo(count: number): string {
  const date = new Date();
  date.setDate(date.getDate() - count);
  return dayString(date);
}
